// extracted by mini-css-extract-plugin
export default {"demoLogo":"styles_demoLogo__OgYcs","logo":"styles_logo__690c3","layout":"styles_layout__pn-u7"};